/* EP Runde 14: ausgelagert aus snippets/ep-variant-select.liquid. defer; wartet selbst auf DOMContentLoaded. Konfiguration: #ep-pdp-config (JSON im Snippet). */
(function () {
  'use strict';

  var CFG = { serving: 0, options: [], title: '', price: 0, pimg: '', contents: '' };
  try {
    var raw = document.getElementById('ep-pdp-config');
    if (raw) CFG = JSON.parse(raw.textContent);
  } catch (e) {}

  var SERVING = parseFloat(CFG.serving) || 0;
  var OPTS = CFG.options || [];
  var SEL = 'product-variants select[data-js-product-variant-container="select"], product-variants select.product-variant-container';
  var SIZE_RE = /(\d+[.,]?\d*)\s*(kg|g|ml|l|kapseln|kapsel|kaps|capsules|caps|tabletten|tabs|st(ue|ü)ck|stk|portionen|portion|gummies|riegel|beutel|shots?|sticks?)\b/i;
  var OUT_RE = /\s*[-–]\s*ausverkauft\s*$/i;
  var CHEVRON = '<svg width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var nf = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var obs = null, timer = null, variants = null, open = null, preDone = false, lastSig = '';

  function money(c) { return nf.format((c || 0) / 100); }
  function clean(t) { return (t || '').replace(OUT_RE, '').trim(); }
  function isOut(o) { return o.getAttribute('data-sold-out') === 'true'; }
  function isPh(o) { return o.disabled || o.value === ''; }
  function inQV(el) { return !!(el && el.closest && el.closest('#product-quick-view')); }
  function root() {
    var all = Array.prototype.slice.call(document.querySelectorAll('product-variants')).filter(function (p) { return !inQV(p); });
    var withVar = all.filter(function (p) { return p.hasAttribute('data-has-variants'); });
    return withVar[0] || all[0] || null;
  }
  function selects() { return Array.prototype.slice.call(document.querySelectorAll(SEL)).filter(function (s) { return !inQV(s); }); }

  function loadVariants() {
    if (variants) return variants;
    var r = root(); if (!r) return null;
    var n = r.querySelector('script[type="application/json"]'); if (!n) return null;
    try { variants = JSON.parse(n.textContent); } catch (e) { variants = null; }
    return variants;
  }

  function optName(sel) {
    var host = sel.parentElement;
    var lbl = host ? host.querySelector('.product-variant__name') : null;
    return lbl ? lbl.textContent.trim() : '';
  }

  function optPos(sel) {
    var n = optName(sel);
    for (var i = 0; i < OPTS.length; i++) {
      if (String(OPTS[i]).toLowerCase() === n.toLowerCase()) return i;
    }
    return selects().indexOf(sel);
  }

  function chosen() {
    var vals = [];
    for (var i = 0; i < Math.max(OPTS.length, 1); i++) vals.push(null);
    selects().forEach(function (s) {
      var o = s.options[s.selectedIndex];
      if (!o || isPh(o)) return;
      var p = optPos(s);
      if (p >= 0) vals[p] = clean(o.textContent);
    });
    return vals;
  }

  function findVariant(vals) {
    var list = loadVariants(); if (!list) return null;
    for (var i = 0; i < list.length; i++) {
      var v = list[i], ok = true;
      for (var k = 0; k < vals.length; k++) {
        if (vals[k] === null) continue;
        if (String(v.options[k]) !== String(vals[k])) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function currentVariant() { return findVariant(chosen()); }

  function variantFor(sel, label) {
    var vals = chosen();
    var p = optPos(sel);
    if (p >= 0) vals[p] = label;
    return findVariant(vals);
  }

  function optionAvailable(sel, label, fallbackOut) {
    var v = variantFor(sel, label);
    if (v) return !!v.available;
    return !fallbackOut;
  }

  function variantImg(v) {
    if (v) {
      if (v.featured_image && v.featured_image.src) return v.featured_image.src;
      if (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) return v.featured_media.preview_image.src;
      if (typeof v.featured_image === 'string' && v.featured_image) return v.featured_image;
    }
    return CFG.pimg || '';
  }

  function withW(src) {
    if (!src) return '';
    if (/[?&]width=/.test(src)) return src;
    if (src.indexOf('/cdn/shop') === -1 && src.indexOf('cdn.shopify') === -1) return src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=144';
  }

  function preselect() {
    if (preDone) return;
    if (/[?&]variant=/.test(location.search)) { preDone = true; return; }
    var list = loadVariants(); if (!list || !selects().length) return;
    preDone = true;
    var cur = currentVariant();
    if (cur && cur.available) return;
    var target = null;
    for (var i = 0; i < list.length; i++) if (list[i].available) { target = list[i]; break; }
    if (!target) return;
    selects().forEach(function (s) {
      var p = optPos(s); if (p < 0) return;
      var want = String(target.options[p]);
      for (var j = 0; j < s.options.length; j++) {
        if (isPh(s.options[j])) continue;
        if (clean(s.options[j].textContent) === want) { s.selectedIndex = j; break; }
      }
      s.dispatchEvent(new Event('change', { bubbles: true }));
    });
    setTimeout(renderAll, 80);
  }

  function isSizeSelect(sel) {
    var hits = 0, total = 0;
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i]; if (isPh(o)) continue;
      total++; if (SIZE_RE.test(clean(o.textContent))) hits++;
    }
    return total > 0 && hits / total >= 0.6;
  }

  function hasSizeSelect() {
    var list = selects();
    for (var i = 0; i < list.length; i++) if (isSizeSelect(list[i])) return true;
    return false;
  }

  function grams(label) {
    var m = SIZE_RE.exec(label); if (!m) return 0;
    var n = parseFloat(String(m[1]).replace(',', '.'));
    var u = m[2].toLowerCase();
    if (u === 'kg' || u === 'l') return n * 1000;
    return n;
  }

  /* EP Runde 28 (18.10.2026) – INP: Der Tipp auf einen Geschmack löste bisher synchron die komplette Variantenkette aus
     (Theme: Preis, Lager, SKU, URL, Formulare, Galerie-Sprung; Bonuspunkte, Klaviyo) – auf dieser riesigen Seite ~110 ms am
     Desktop, 300–500 ms am Handy, und Google rechnet das alles der Interaktion zu (INP 216 ms). Jetzt zeichnet der Browser
     erst das Sichtbare (Liste zu, neuer Name im Feld, Karte aktiv) und die Kette läuft im nächsten Frame nach. Für den
     Nutzer identisch, nur der Preis wechselt einen Frame später. */
  function pick(sel, index) {
    if (index < 0 || index >= sel.options.length) return;
    if (isPh(sel.options[index])) return;
    sel.selectedIndex = index;
    try {
      var r0 = sel.epvRef;
      if (r0 && r0.btn) {
        var t0 = r0.btn.querySelector('.epv-btn__text');
        if (t0) t0.textContent = clean(sel.options[index].textContent);
        var items = r0.list.querySelectorAll('.epv-item');
        for (var q = 0; q < items.length; q++) items[q].setAttribute('aria-selected', items[q].getAttribute('data-epi') === String(index) ? 'true' : 'false');
      }
    } catch (e0) {}
    var fire = function () {
      sel.dispatchEvent(new Event('input', { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(renderAll, 40);
    };
    if (window.requestAnimationFrame) { requestAnimationFrame(function () { setTimeout(fire, 0); }); }
    else { setTimeout(fire, 0); }
  }

  function makeCard(opts) {
    var b = document.createElement(opts.button ? 'button' : 'div');
    if (opts.button) b.type = 'button';
    b.className = 'ep-size' + (opts.active ? ' is-active' : '') + (opts.out ? ' is-out' : '') + (opts.button ? '' : ' ep-size--static');
    if (opts.epi != null) b.setAttribute('data-epi', String(opts.epi));
    if (opts.img) {
      var im = document.createElement('img');
      im.className = 'ep-size__img'; im.src = opts.img; im.alt = ''; im.loading = 'lazy';
      b.appendChild(im);
    }
    var n1 = document.createElement('span');
    n1.className = 'ep-size__name'; n1.textContent = opts.name; b.appendChild(n1);
    if (opts.sub) {
      var s1 = document.createElement('span');
      s1.className = 'ep-size__sub'; s1.textContent = opts.sub; b.appendChild(s1);
    }
    if (opts.price != null) {
      var p1 = document.createElement('span');
      p1.className = 'ep-size__price'; p1.textContent = money(opts.price);
      if (opts.compare && opts.compare > opts.price) {
        var oldEl = document.createElement('span');
        oldEl.className = 'ep-size__old'; oldEl.textContent = money(opts.compare);
        p1.appendChild(document.createTextNode(' '));
        p1.appendChild(oldEl);
      }
      b.appendChild(p1);
    }
    if (opts.out) {
      var f1 = document.createElement('span');
      f1.className = 'ep-size__flag'; f1.textContent = 'Ausverkauft'; b.appendChild(f1);
    } else if (opts.per) {
      var e1 = document.createElement('span');
      e1.className = 'ep-size__per'; e1.textContent = opts.per; b.appendChild(e1);
    }
    return b;
  }

  function buildSizes(sel, host) {
    var rows = [];
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i]; if (isPh(o)) continue;
      var label = clean(o.textContent);
      rows.push({ i: i, label: label, g: grams(label), out: isOut(o) });
    }
    rows.sort(function (a, b) { return a.g - b.g; });

    var wrap = document.createElement('div');
    wrap.className = 'ep-sizes';

    rows.forEach(function (r) {
      var v = variantFor(sel, r.label);
      var cents = v ? v.price : null;
      var comp = v ? v.compare_at_price : null;
      var per = '';
      if (!r.out && cents !== null) {
        if (SERVING > 0 && r.g > 0) per = money(cents / Math.max(1, Math.round(r.g / SERVING))) + ' / Portion';
        else if (r.g > 0) per = money(cents / (r.g / 1000)) + ' / kg';
      }
      var sub = (SERVING > 0 && r.g > 0) ? (Math.max(1, Math.round(r.g / SERVING)) + (Math.max(1, Math.round(r.g / SERVING)) === 1 ? ' Portion' : ' Portionen')) : '';
      wrap.appendChild(makeCard({
        button: true, epi: r.i, active: r.i === sel.selectedIndex, out: r.out,
        img: withW(variantImg(v)), name: r.label, sub: sub,
        price: cents !== null ? cents : null, compare: comp, per: per
      }));
    });

    wrap.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.ep-size') : null;
      if (b && b.hasAttribute('data-epi')) pick(sel, parseInt(b.getAttribute('data-epi'), 10));
    });

    var scroller = document.createElement('div');
    scroller.className = 'ep-sizes-wrap';
    scroller.appendChild(wrap);
    host.appendChild(scroller);

    function syncEnd() {
      var end = wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 2;
      scroller.classList.toggle('is-end', end);
    }
    wrap.addEventListener('scroll', syncEnd, { passive: true });

    requestAnimationFrame(function () {
      try {
        if (wrap.scrollWidth > wrap.clientWidth + 2) {
          scroller.classList.add('is-scrollable');
          syncEnd();
        }
      } catch (e) {}
    });
  }

  // Ein-Groessen-Produkt: eine statische Karte, UNTER den Geschmack gesetzt
  function buildSingleSize() {
    var pv = root(); if (!pv) return;
    if (pv.querySelector('.ep-single-size')) return;
    var v = null, list = loadVariants();
    if (list && list.length) v = list[0];
    var price = v ? v.price : CFG.price;
    var comp = v ? v.compare_at_price : null;
    var img = withW(variantImg(v));
    /* Runde 11: Größe aus dem Titel, sonst aus dem Inhalt-Metafeld ("60 Kapseln"); ohne beides keine Karte ("Einheitsgröße" sagt nichts) */
    var m = SIZE_RE.exec(CFG.title || '');
    var name = m ? clean(m[0]) : '';
    if (!name && CFG.contents) { var m2 = SIZE_RE.exec(String(CFG.contents)); name = m2 ? clean(m2[0]) : String(CFG.contents).trim(); }
    if (!name) return;
    var g = grams(name);
    var sub = (SERVING > 0 && g > 0) ? (Math.max(1, Math.round(g / SERVING)) + ' Portionen') : '';
    var per = (SERVING > 0 && g > 0 && price) ? (money(price / Math.max(1, Math.round(g / SERVING))) + ' / Portion') : '';

    var host = document.createElement('div');
    host.className = 'ep-ui ep-single-size';
    var h = document.createElement('div'); h.className = 'ep-label';
    var s = document.createElement('span'); s.textContent = 'Größe'; h.appendChild(s);
    host.appendChild(h);
    var scroller = document.createElement('div'); scroller.className = 'ep-sizes-wrap';
    var wrap = document.createElement('div'); wrap.className = 'ep-sizes';
    wrap.appendChild(makeCard({ button: false, active: true, img: img, name: name, sub: sub, price: price || null, compare: comp, per: per }));
    scroller.appendChild(wrap);
    host.appendChild(scroller);

    var anchor = pv.querySelector('.product-variants--select') || pv.querySelector('.product-variants--radio');
    if (anchor && anchor.parentNode === pv) pv.insertBefore(host, anchor.nextSibling);
    else pv.insertBefore(host, pv.firstChild);
  }

  function closeList(sel) {
    var r = sel && sel.epvRef; if (!r) return;
    r.list.hidden = true;
    r.btn.setAttribute('aria-expanded', 'false');
    if (open === sel) open = null;
  }

  function showList(sel) {
    if (open && open !== sel) closeList(open);
    var r = sel.epvRef;
    r.list.hidden = false;
    r.btn.setAttribute('aria-expanded', 'true');
    open = sel;
    var a = r.list.querySelector('[aria-selected="true"]');
    if (a && a.scrollIntoView) a.scrollIntoView({ block: 'nearest' });
  }

  function buildDropdown(sel, host, name) {
    var rows = [];
    var inN = 0, allN = 0;
    for (var j = 0; j < sel.options.length; j++) {
      var o2 = sel.options[j]; if (isPh(o2)) continue;
      var lab = clean(o2.textContent);
      var avail = optionAvailable(sel, lab, isOut(o2));
      allN++; if (avail) inN++;
      rows.push({ i: j, label: lab, out: !avail });
    }
    rows.sort(function (a, b) { return (a.out ? 1 : 0) - (b.out ? 1 : 0) || a.i - b.i; });

    var displayName = (!name || name.toLowerCase() === 'geschmack') ? 'Wähle deinen Geschmack' : name;

    var head = document.createElement('div');
    head.className = 'ep-label';
    var l1 = document.createElement('span'); l1.textContent = displayName;
    var c1 = document.createElement('span'); c1.className = 'ep-label__count';
    c1.textContent = inN + ' von ' + allN + ' verfügbar';
    head.appendChild(l1); head.appendChild(c1);
    host.appendChild(head);

    var shell = document.createElement('div');
    shell.style.position = 'relative';
    shell.style.marginBottom = '22px';
    host.appendChild(shell);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'epv-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML =
      '<span class="epv-btn__label"><span class="epv-dot"></span><span class="epv-btn__text"></span></span>' +
      '<span class="epv-btn__icon">' + CHEVRON + '</span>';

    var list = document.createElement('div');
    list.className = 'epv-list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    shell.appendChild(btn);
    shell.appendChild(list);
    sel.epvRef = { btn: btn, list: list };

    rows.forEach(function (r) {
      var it = document.createElement('div');
      it.className = 'epv-item ' + (r.out ? 'is-out' : 'is-in');
      it.setAttribute('role', 'option');
      it.setAttribute('data-epi', String(r.i));
      it.setAttribute('aria-selected', r.i === sel.selectedIndex ? 'true' : 'false');
      var d = document.createElement('span'); d.className = 'epv-dot';
      var t = document.createElement('span'); t.className = 'epv-item__text'; t.textContent = r.label;
      it.appendChild(d); it.appendChild(t);
      if (r.out) {
        var f = document.createElement('span');
        f.className = 'epv-flag'; f.textContent = 'Ausverkauft'; it.appendChild(f);
      }
      list.appendChild(it);
    });

    var cur = sel.options[sel.selectedIndex];
    btn.classList.remove('is-in');
    if (cur && !isPh(cur)) {
      var curLabel = clean(cur.textContent);
      btn.querySelector('.epv-btn__text').textContent = curLabel;
      if (optionAvailable(sel, curLabel, isOut(cur))) btn.classList.add('is-in');
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (list.hidden) showList(sel); else closeList(sel);
    });
    list.addEventListener('click', function (e) {
      var it = e.target.closest ? e.target.closest('.epv-item') : null;
      if (!it) return;
      e.preventDefault(); e.stopPropagation();
      closeList(sel);
      pick(sel, parseInt(it.getAttribute('data-epi'), 10));
    });
  }

  // Groesse UNTER den Geschmack setzen (nur CSS-order, HTML unveraendert)
  function orderVisual() {
    var list = selects();
    if (list.length < 2) return;
    var sizeSel = null;
    for (var i = 0; i < list.length; i++) if (isSizeSelect(list[i])) { sizeSel = list[i]; break; }
    if (!sizeSel) return;
    var block = sizeSel.closest ? sizeSel.closest('[data-js-product-variant]') : null;
    if (!block || !block.parentNode) return;
    var container = block.parentNode;
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    var blocks = container.querySelectorAll('[data-js-product-variant]');
    for (var k = 0; k < blocks.length; k++) blocks[k].style.order = '0';
    block.style.order = '1';
  }

  function currentSig() {
    return selects().map(function (s) { return s.selectedIndex; }).join('|') + '#' + selects().length;
  }

  function renderPickers() {
    var sig = currentSig();
    var built = document.querySelector('.ep-ui:not(#product-quick-view .ep-ui)');
    if (built && sig === lastSig) return;
    lastSig = sig;

    selects().forEach(function (sel) {
      var host = sel.parentElement; if (!host) return;
      host.classList.add('epv-host');
      sel.classList.add('epv-native');
      sel.setAttribute('tabindex', '-1');
      sel.setAttribute('aria-hidden', 'true');

      var old = host.querySelector('.ep-ui');
      if (old) old.remove();

      var lbl = host.querySelector('.product-variant__name');
      var name = lbl ? lbl.textContent.trim() : '';
      if (lbl) lbl.style.display = 'none';

      var ui = document.createElement('div');
      ui.className = 'ep-ui';
      host.appendChild(ui);

      if (isSizeSelect(sel)) {
        var h = document.createElement('div');
        h.className = 'ep-label';
        var s = document.createElement('span');
        s.textContent = name || 'Größe';
        h.appendChild(s);
        ui.appendChild(h);
        buildSizes(sel, ui);
      } else {
        buildDropdown(sel, ui, name);
      }
    });

    if (!hasSizeSelect()) buildSingleSize();
  }

  /* ---------- Rabatt-Badge (%) am Preis oben + Inhalt hinter dem Grundpreis ---------- */
  function currentVariant() {
    var f = document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');
    var inp = f ? f.querySelector('[name="id"]') : null;
    var list = loadVariants() || [];
    if (inp) { for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(inp.value)) return list[i]; }
    if (list[0]) return list[0];
    return { id: 0, price: CFG.price || 0, compare_at_price: CFG.cmp || 0 };
  }
  function renderPriceExtras() {
    var box = document.querySelector('.product-text [data-js-product-price-compact]');
    if (!box || inQV(box)) return;
    var v = currentVariant();
    var cmp = box.querySelector('[data-js-product-price-compare]');
    var badge = box.querySelector('.ep-sale-badge');
    var pct = (v && v.compare_at_price && v.compare_at_price > v.price) ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
    if (pct > 0) {
      if (!badge) { badge = document.createElement('span'); badge.className = 'ep-sale-badge'; if (cmp && cmp.parentNode) cmp.parentNode.insertBefore(badge, cmp.nextSibling); else box.appendChild(badge); }
      badge.textContent = '-' + pct + ' %'; badge.hidden = false;
    } else if (badge) { badge.hidden = true; }
    /* Variante A: der Inhalt steht auf der Größen-Karte, kein Zusatz hinter dem Grundpreis */
    var ex = box.querySelector('.ep-unit-contents'); if (ex) ex.remove();
  }

  function renderAll() {
    if (open) return;
    try { renderPriceExtras(); } catch (e) {}
    if (obs) obs.disconnect();
    try {
      orderVisual(); preselect(); renderPickers();
    } catch (e) {}
    var pvReady = root(); if (pvReady) pvReady.classList.add('epv-ready');
    if (obs) obs.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    if (!open) return;
    var r = open.epvRef;
    if (r && (r.btn.contains(e.target) || r.list.contains(e.target))) return;
    closeList(open);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && open) closeList(open);
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.tagName === 'SELECT' && !inQV(e.target)) { lastSig = ''; setTimeout(renderAll, 40); setTimeout(renderPriceExtras, 400); }
  }, true);

  function start() {
    obs = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(renderAll, 140);
    });
    renderAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
